import { FormatByte } from "~/components/common"
import React, { FC } from "react"
import VideoService from "~/services/VideoService"
import config from "~/config"
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap"
import { withI18n, withUser } from "~/hocs"
import cookie from "cookie-cutter"
import { connect } from "react-redux"
import { setDownloadInfo } from "~/store/video/actions"
import { makeSelectDownloadInfo } from "~/store/video/selector"
import { createStructuredSelector } from "reselect"
import { redirectLogin, redirectSignUp } from "~/utils"
import { bindActionCreators, Dispatch } from "redux"
import { useSession } from "next-auth/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload, faVolumeUp } from "@fortawesome/free-solid-svg-icons"
import FirstDLModal from "~/components/modals/FirstDLModal"
import DownloadInfoService from "~/services/DownloadInfoService"
import SecondDLModal from "~/components/modals/SecondDLModal"
import ADsModal from "~/components/modals/ADsModal"
import moment from "moment-timezone"
import { makeSelectProfile } from "~/store/auth/selector"
import moment2 from "moment"
import DLModal from "~/components/modals/DLModal"

const DownloadVideo: FC<any> = ({
  videoStocks,
  token,
  t,
  lng,
  downloadInfo,
  isAuthen,
  isPremium,
  setDownloadInfo,
  userID,
  profile,
}) => {
  const [downloading, setDownloading] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [value, setValue] = React.useState(0)
  const [downloadURL, setDownloadURL] = React.useState(undefined)
  const { data: nextAuthSession } = useSession()
  const isCreator = !!nextAuthSession?.user.creatorId
  const [show, setShow] = React.useState(false)
  const target = React.useRef(null)
  const [hoveredButtonIndex, setHoveredButtonIndex] = React.useState(-1)
  const [showModalFirstDL, setShowModalFirstDL] = React.useState(false)
  const [showModalSecondDL, setShowModalSecondDL] = React.useState(false)
  const [showModalAdsDL, setShowModalAdsDL] = React.useState(false)
  const imageUrl1 = `${process.env.ASSET_PREFIX}/asset/image/50_1.png`
  const imageUrl2 = `${process.env.ASSET_PREFIX}/asset/image/banner/banner_download_04_2025.png`
  const [emailToken, setEmailToken] = React.useState("")
  const [countDL, setCountDL] = React.useState(0)
  const now = moment().tz("Asia/Tokyo")
  const startDate = moment.tz('2025-04-24 00:00:00', 'Asia/Tokyo')
  const endDate = moment.tz('2025-05-01 00:00:00', 'Asia/Tokyo')
  const is_paused_premium =
    profile?.premium_info?.pause_end_date &&
    moment2(profile?.premium_info?.pause_end_date, "YYYY-MM-DD").valueOf() >
      moment2().valueOf()
  const [showModalDL, setShowModalDL] = React.useState(false)
  const [isWatchedADs, setIsWatchedAds] = React.useState(false)
  const handleShowModalFirstDL = () => setShowModalFirstDL(true)
  const handleHideModalFirstDL = () => setShowModalFirstDL(false)

  const handleShowModalSecondDL = () => setShowModalSecondDL(true)
  const handleHideModalSecondDL = () => setShowModalSecondDL(false)

  const handleShowModalAdsDL = () => {
    if (showModalDL) {
      handleHideModalDL()
    }
    setShowModalAdsDL(true)
  }
  const handleHideModalAdsDL = () => setShowModalAdsDL(false)

  const handleShowModalDL = () => setShowModalDL(true)
  const handleHideModalDL = () => {
    setIsWatchedAds(true)
    setShowModalDL(false)
  }

  const onChange = (e: React.MouseEvent) => {
    setValue(Number(e.target.value))
  }
  React.useEffect(() => {
    if (isAuthen && !isPremium) {
      checkFirstDownload()
    }
  }, [])

  React.useEffect(() => {
    if (!isPremium && isAuthen) {
      setLoading(true)
      VideoService.getDownloadInfo(token, {
        premium_info: profile?.premium_info,
      })
        .then((res: any) => {
          if (res.max_download > -1) {
            setDownloadInfo({
              remain_download: res.remain_download,
            })
            // const date = new Date()
            // const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
            // const cookieCfg = { httpOnly: false, path: '/', expires: midnight }
            // cookies.set('last_download_at', res.last_download_at, cookieCfg)
            // cookies.set('remain_download', `${res.remain_download}`, cookieCfg)
          } else {
            // const expired = { expires: 'Thu, 01 Jan 1970 00:00:00 GMT' }
            // cookies.set('last_download_at', '', expired)
            // cookies.set('remain_download', '', expired)
          }
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          console.log(err)
        })
      // const remainDownload = cookie.get('remain_download')
      // setDownloadInfo({
      //   remain_download: remainDownload && parseInt(remainDownload),
      // })
    } else {
      if (isPremium && is_paused_premium) {
        setLoading(true)
        VideoService.getDownloadInfo(token, {
          is_paused_premium,
        })
          .then((res: any) => {
            if (res.max_download > -1) {
              setDownloadInfo({
                remain_download: res.remain_download,
              })
            }
            setLoading(false)
          })
          .catch((err) => {
            setLoading(false)
            console.log(err)
          })
      }
    }
  }, [])

  const handleDownloadFile = async () => {
    const videoStock = videoStocks[value]
    setDownloading(true)

    try {
      const res = await VideoService.download(token, {
        stock_id: videoStock.id,
        is_paused_premium,
      })
      setDownloadURL(res.url)

      const cookieCfg = { path: "/" }
      cookie.set("last_download_at", res.last_download_at, cookieCfg)
      cookie.set("remain_download", res.remain_download, cookieCfg)
      setDownloadInfo(res)

      if (countDL < 3) {
        checkFirstDownload()
      }
    } catch (err) {
      console.error(err)
    } finally {
      setDownloading(false)
      if (isAuthen && !isPremium) {
        if (countDL === 0) {
          handleShowModalFirstDL()
        } else if (countDL === 1 && now.isBetween(startDate, endDate)) {
          handleShowModalSecondDL()
        }
      }
    }
  }
  const isAdBlockEnabled = async () => {
    try {
      // Phát hiện AdBlock bằng cách thử tải một tài nguyên thường bị AdBlock chặn
      const response = await fetch(
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
        {
          method: "HEAD",
          mode: "no-cors",
        },
      )
      return false // Nếu tải thành công, AdBlock không được bật
    } catch (error) {
      return true // Nếu lỗi xảy ra, AdBlock có thể đã chặn
    }
  }

  const createSlotAd = async () => {
    if (isWatchedADs) {
      handleShowModalDL()
    } else {
      console.log(
        "----------------------------------------------> Start create slot",
      )
      const googletag = window.googletag
      console.log(
        "----------------------------------------------> window.googletag: ",
        googletag,
      )
  
      if (googletag) {
        googletag.cmd.push(function () {
          let slotAd = googletag.defineOutOfPageSlot(
            "/17939840/video_Rewarded_Ads",
            googletag.enums.OutOfPageFormat.REWARDED,
          )
          let slotPayload
  
          console.log(
            "----------------------------------------------> Start create slot: ",
            slotAd,
          )
  
          if (slotAd) {
            googletag.pubads().enableSingleRequest()
            slotAd.addService(googletag.pubads())
            googletag.pubads().addEventListener("rewardedSlotReady", (event) => {
              console.log("rewardedSlotReady", event)
              event.makeRewardedVisible()
            })
            googletag.pubads().addEventListener("rewardedSlotClosed", () => {
              console.log("rewardedSlotClosed")
              if (slotPayload) {
                handleShowModalDL()
                slotPayload = null
              }
              if (slotAd) googletag.destroySlots([slotAd])
            })
            googletag
              .pubads()
              .addEventListener("rewardedSlotGranted", (event) => {
                slotPayload = event.payload
                console.log("rewardedSlotGranted")
                try {
                  const iframes = document.querySelectorAll("iframe")
                  const adsIframe = Array.from(iframes).find((frame) =>
                    frame?.id?.includes("17939840/design_Rewarded_Ads"),
                  )
                  if (adsIframe) {
                    const iframeDoc =
                      adsIframe.contentDocument ||
                      adsIframe.contentWindow.document
                    const closeBtn = iframeDoc.getElementById("close_button")
                    if (closeBtn) closeBtn.click()
                  }
                } catch (error) {
                  console.error("Error: ", error)
                }
              })
            googletag.pubads().addEventListener("slotRenderEnded", (event) => {
              console.log("slotRenderEnded", event)
              if (event.slot === slotAd && event.isEmpty) {
                console.log("No ad returned for rewarded ad slot.")
                handleShowModalAdsDL()
              }
            })
            googletag.enableServices()
            googletag.display(slotAd)
          }
        })
      }
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const isAdBlocked = await isAdBlockEnabled()
    if (isPremium) {
      if (is_paused_premium) {
        if (isAdBlocked) {
          handleShowModalAdsDL()
        } else {
          createSlotAd()
        }
      } else {
        handleDownloadFile()
      }
    } else {
      if (isAdBlocked) {
        handleShowModalAdsDL()
      } else {
        createSlotAd()
      }
    }
  }

  const redirectPremium = () => {
    window.open(
      "https://premium.photo-ac.com/premium/campaign?ref=videoAC",
      "_blank",
    )
  }
  const renderBtnDownload = (props: any) => {
    const renderTooltip = (props: any) => (
      <Tooltip id="button-tooltip" {...props}>
        無料会員様はnHD、qHD、HDサイズのみダウンロード可能です。
        <strong>
          <a className="ac-text-blue" target="_blank" href={config.premiumUrl}>
            プレミアム会員
          </a>
        </strong>
        になるとFHD、4Kサイズも無制限でダウンロード可能です。プレミアム会員については
        <strong>
          <a className="ac-text-blue" target="_blank" href={config.premiumUrl}>
            こちら
          </a>
        </strong>
      </Tooltip>
    )

    const isDisabled =
      isAuthen &&
      !isCreator &&
      !isPremium &&
      videoStocks[value] &&
      config.resolutions[videoStocks[value].type_id].isPremium
    if (isDisabled) {
      return (
        <div
          className="flex-center mt-2"
          style={{ width: "100%", flexDirection: "column" }}
        >
          <style jsx global>
            {`
              .tooltip-inner {
                border-radius: 0;
                max-width: 286px;
              }
            `}
          </style>
          <OverlayTrigger
            placement="bottom"
            overlay={renderTooltip}
            trigger="click"
            rootClose={true}
          >
            <Button
              size={"large"}
              {...props}
              disabled={props.loading}
              onClick={false}
            >
              {props.loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {props.title}
            </Button>
          </OverlayTrigger>
        </div>
      )
    } else {
      return (
        <div
          className="flex-center mt-2"
          style={{ width: "100%", flexDirection: "column" }}
        >
          <Button size={"large"} {...props} disabled={props.loading}>
            {props.loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            <FontAwesomeIcon icon={faDownload} className="mr-2" />
            {props.title}
          </Button>
        </div>
      )
    }
  }
  // const renderBtnPremium = () => {
  //   if (isPremium || (isAuthen && !downloadInfo.remain_download)) return <></>
  //   return (
  //     <>
  //       <div className="dropdown-divider" />
  //       <div className="download-section-premium">
  //         <span className="d-block mt-3 bold">{t('download_upgrade_premium_title')}</span>
  //         <span className="tiny">{t('download_upgrade_premium_desscription')}</span>
  //         <Button className="bold mt-3 mb-2" variant="outline-premium" onClick={redirectPremium}>
  //           {t('go_premium')}
  //         </Button>
  //       </div>
  //     </>
  //   )
  // }
  const checkFirstDownload = async () => {
    await DownloadInfoService.checkFirstDownload({
      user_id: userID,
    })
      .then((res) => {
        if (res?.result?.email) {
          if (res?.result?.count === 0) {
            setEmailToken(btoa(res?.result?.email))
          }
          setCountDL(res?.result?.count)
        } else {
          setEmailToken("")
        }
      })
      .catch((err) => {
        alert("エラー")
        console.log(err)
      })
  }
  return (
    <>
      <div className="download">
        <iframe src={downloadURL} title="title" style={{ display: "none" }}>
          <a id="anchor-download" href={downloadURL} download />
        </iframe>
        <FirstDLModal
          show={showModalFirstDL}
          onHide={handleHideModalFirstDL}
          imageUrl={imageUrl1}
          emailToken={emailToken}
        />
        <SecondDLModal
          show={showModalSecondDL}
          onHide={handleHideModalSecondDL}
          imageUrl={imageUrl2}
        />
        <ADsModal
          show={showModalAdsDL}
          onHide={handleHideModalAdsDL}
          handleShowModalDL={handleShowModalDL}
          handleHideModalDL={handleHideModalDL}
        />
        <DLModal
          show={showModalDL}
          onHide={handleHideModalDL}
          videoStocks={videoStocks}
          onChange={onChange}
          value={value}
          setValue={setValue}
          handleDownloadFile={handleDownloadFile}
        />

        <Form onSubmit={handleSubmit} defaultValue={0}>
          <Form.Group>
            {!isAuthen || (isPremium && !is_paused_premium) ?  (
              <div className="video-item-download-info">
                {videoStocks.map((item: any, idx: number) => {
                  const type = config.resolutions[item.type_id]
                  const tooltipClass =
                    idx === hoveredButtonIndex
                      ? "download-button-tooltip show"
                      : "download-button-tooltip"
                  return (
                    <>
                      <div
                        onMouseEnter={() => setHoveredButtonIndex(idx)}
                        onMouseLeave={() => setHoveredButtonIndex(-1)}
                      >
                        <div className={tooltipClass}>{type.tooltipHover}</div>
                        <Form.Check
                          className={`mb-1 ${
                            item.type_id >= 4
                              ? "form-check-download position-relative"
                              : "position-relative"
                          }`}
                          defaultChecked={idx === value}
                          onClick={onChange}
                          type="radio"
                          id={`download-${idx}`}
                          key={idx}
                          name="download"
                          value={idx}
                          disabled={
                            item.type_id >= 4 && isPremium && is_paused_premium
                          }
                          label={
                            <>
                              {!isPremium && (
                                <div className="popup">
                                  <a
                                    href="https://premium.photo-ac.com/premium/campaign?ref=videoAC"
                                    target="_blank"
                                    style={{ color: "#82DCAA" }}
                                  >
                                    プレミアム会員
                                  </a>
                                  になるとFHD、4K サイズも無制限でダウンロード
                                  可能です。プレミアム会員につい
                                  <a
                                    href="https://premium.photo-ac.com/premium/campaign?ref=videoAC"
                                    target="_blank"
                                    style={{ color: "#82DCAA" }}
                                  >
                                    てはこちら
                                  </a>
                                </div>
                              )}
                              <span
                                className="font-weight-bold"
                                style={{ display: "inline-block" }}
                              >
                                {type.name}
                              </span>
                              <span
                                className="text-secondary small"
                                style={{ display: "inline-block" }}
                              >
                                {item.width} x {item.height}px
                              </span>
                              <span
                                className="text-secondary small"
                                style={{ display: "inline-block" }}
                              >
                                <FormatByte value={item.size} />
                                {item.type_id >= 4 && (
                                  <img
                                    className="mw-100 ml-2 mb-2 lazy loaded"
                                    alt="プレミアム会員登録"
                                    width="20"
                                    src="https://jp.static.photo-ac.com/assets/img/responsive/ico_premium.png"
                                    data-ll-status="loaded"
                                  />
                                )}
                              </span>
                            </>
                          }
                        />
                      </div>
                    </>
                  )
                })}
              </div>
            ) : (
              <Row>
                {videoStocks.slice(0, 3).map((item: any, idx: number) => {
                  const resolutions = {
                    1: {
                      id: 1,
                      name: 'モバイル（S）',
                      price: -1,
                      isPremium: false,
                      tooltipHover: 'SD / 360p'
                    },
                    2: {
                      id: 2,
                      name: 'モバイル（L）',
                      price: -1,
                      isPremium: false,
                      tooltipHover: 'SD / 540p'
                    },
                    3: {
                      id: 3,
                      name: 'HD',
                      price: -1,
                      isPremium: false,
                      tooltipHover: 'ハイビジョン / 720p'
                    },
                  };
                  const type = resolutions[item.type_id];

                  return (
                    <Col key={idx}>
                      <div
                        className={`${
                          idx === 2 ? '' : 'border-right'
                        } ac-p-2 text-center h-100 d-flex align-items-center flex-column justify-content-center ac-heading-6`}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-${idx}`}>
                              {type.tooltipHover}
                            </Tooltip>
                          }
                        >
                          <span className="text-type-name" style={{ display: 'inline-block', fontSize: '14px', cursor: 'pointer', fontWeight: "bold" }}>
                            {type.name}
                          </span>
                        </OverlayTrigger>
                        <p className="text-center mb-0 text-byte">
                          <small>
                            <FormatByte value={item.size} />
                          </small>
                        </p>
                        <p className="text-center text-size mb-0">
                          <small>
                            {item.width} x {item.height}px
                          </small>
                        </p>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
            {!loading ? (
              isAuthen && !isCreator ? (
                isPremium ? (
                  is_paused_premium ? (
                    downloadInfo.remain_download ? (
                      <>
                        {renderBtnDownload({
                          title: t("download"),
                          onClick: handleSubmit,
                          loading: downloading,
                        })}
                        <div className="text-center mt-3 h-100 d-flex align-items-center flex-column justify-content-center">
                          <p className="mb-1" style={{fontSize: "12px", color: "#6C757D"}}>視聴後、広告を閉じると素材ページに移動します。</p>
                          <p className="mb-1" style={{fontSize: "12px",color: "#6C757D"}}><FontAwesomeIcon icon={faVolumeUp} className="mr-2" />音声入りの動画広告が再生される場合があります。</p>
                          <p className="mb-1 hover-primary" style={{fontSize: "16px", fontWeight: "bold", textDecoration: "underline"}}><a href={config.premiumUrl} target="_blank">すぐダウンロードする方法は？</a></p>
                        </div>
                      </>
                    ) : (
                      <>
                        {renderBtnDownload({
                          title: t("download_upgrade_premium_title"),
                          onClick: redirectPremium,
                        })}
                      </>
                    )
                  ) : (
                    <>
                      {renderBtnDownload({
                        title: t("download"),
                        onClick: handleSubmit,
                        loading: downloading,
                      })}
                    </>
                  )
                ) : downloadInfo.remain_download ? (
                  <>
                    {renderBtnDownload({
                      title: t("download"),
                      onClick: handleSubmit,
                      loading: downloading,
                    })}
                    <div className="text-center mt-3 h-100 d-flex align-items-center flex-column justify-content-center">
                      <p className="mb-1" style={{fontSize: "12px", color: "#6C757D"}}>視聴後、広告を閉じると素材ページに移動します。</p>
                      <p className="mb-1" style={{fontSize: "12px",color: "#6C757D"}}><FontAwesomeIcon icon={faVolumeUp} className="mr-2" />音声入りの動画広告が再生される場合があります。</p>
                      <p className="mb-1 hover-primary" style={{fontSize: "16px", fontWeight: "bold", textDecoration: "underline"}}><a href={config.premiumUrl} target="_blank">すぐダウンロードする方法は？</a></p>
                     </div>
                  </>
                ) : (
                  <>
                    {renderBtnDownload({
                      title: t("download_upgrade_premium_title"),
                      onClick: redirectPremium,
                    })}
                  </>
                )
              ) : (
                <OverlayTrigger
                  key="top"
                  placement="top"
                  trigger="click"
                  overlay={
                    <Tooltip id={"tooltip-top"}>
                      先に
                      <a
                        className="tooltip-download-link"
                        onClick={() => redirectLogin(lng)}
                      >
                        ログイン
                      </a>
                      をお願いします。 初めての方は
                      <a
                        onClick={() => redirectSignUp(lng)}
                        className="tooltip-download-link"
                      >
                        無料会員登録
                      </a>
                    </Tooltip>
                  }
                >
                  <div
                    className="text-center mt-3"
                    style={{ color: "#1C74B3" }}
                  >
                    {/* <a href={config.premiumUrl} target="_blank">1日に10点以上ダウンロードする方法は？</a> */}
                    <span className="text-decoration-none ac-btn-md ac-btn-photo w-100 justify-content-center custom-shadow historyDowloads">
                      <FontAwesomeIcon icon={faDownload} className="mr-2" />
                      ダウンロード
                    </span>
                  </div>
                </OverlayTrigger>
              )
            ) : (
              <div className="d-flex justify-content-center">
                <div
                  id="loading-spin"
                  className="spinner-border text-secondary"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
            {!isPremium && (
              <div className="text-center mt-3" style={{ color: "#1C74B3" }}>
                <a href={config.premiumUrl} target="_blank">
                  1日に10点以上ダウンロードする方法は？
                </a>
              </div>
            )}
          </Form.Group>
        </Form>
      </div>
    </>
  )
}
const mapStateToProps = createStructuredSelector({
  downloadInfo: makeSelectDownloadInfo(),
  profile: makeSelectProfile(),
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ setDownloadInfo }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withUser(withI18n(DownloadVideo)))
